import React from "react";
import BlockUi from "react-block-ui";

export default function BulkQueriesCard({ product, isLoading, onToggle }) {
  const enabled = product?.enabled;

  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-5">
      <BlockUi tag="div" blocking={isLoading} style={{ height: "100%" }}>
        <div style={{ backgroundColor: "#fff", padding: "30px", borderRadius: "10px", border: "1px solid #eaeaea", height: "100%" }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
            <div style={{ width: 50, height: 50, borderRadius: "50%", backgroundColor: "#EEF0FF", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 15 }}>
              <i className="fas fa-cube" style={{ color: "#6c63ff", fontSize: 22 }} />
            </div>
            <h2 className="azul-cabecalho" style={{ lineHeight: 1, marginBottom: 0 }}>
              Consulta em Lote
            </h2>
          </div>

          <p className="subheader-text" style={{ marginBottom: 0 }}>
            Habilita ou desabilita a consulta processual em lote para o cliente.
          </p>

          <div style={{ marginTop: 20, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <p className="tipo-campo">STATUS</p>
              {/* label só reflete o enabled vindo do GET (fonte da verdade) */}
              <p className="campo" style={{ fontWeight: "bold", margin: 0, color: enabled ? "#01AB7D" : "#F64E60" }}>
                {enabled ? "Habilitado" : "Desabilitado"}
              </p>
            </div>

            {/* switch Metronic — checked = enabled; alternar chama onToggle(novoValor) */}
            <span className="switch switch-icon">
              <label>
                <input
                  type="checkbox"
                  checked={!!enabled}
                  disabled={isLoading}
                  onChange={(e) => onToggle(e.target.checked)}
                />
                <span></span>
              </label>
            </span>
          </div>
        </div>
      </BlockUi>
    </div>
  );
}